import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataInterestRatesActions } from "./interest-rates.actions";

// **************************************************************************
// INTEREST RATES REDUCER
// **************************************************************************

const load = on(DataInterestRatesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        interestRate: {
            ...state.data.interestRate,
            interestRatesLoading: true,
        },
    },
}));

const loadSuccess = on(DataInterestRatesActions.loadSuccess, (state: ApplicationStore, { interestRates }) => ({
    ...state,
    data: {
        ...state.data,
        interestRate: {
            ...state.data.interestRate,
            interestRates,
            interestRatesLoading: false,
        },
    },
}));

const loadFailure = on(DataInterestRatesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        interestRate: {
            ...state.data.interestRate,
            interestRatesLoading: false,
        },
    },
}));

export const interestRatesReducer = [load, loadSuccess, loadFailure];
